import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  loading: false,
  error: false,
  submitted: false,
  errorMessage: "",
};
const submitDAFReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.POST_DAF_STARTED:
      return updateObject(state, {
        loading: true,
        error: false,
        submitted: false,
        errorMessage: "",
      });
    case actionTypes.POST_DAF_SUCCESS:
      return updateObject(state, {
        loading: false,
        error: false,
        submitted: true,
        errorMessage: "",
      });
    case actionTypes.POST_DAF_FAILED:
      return updateObject(state, {
        loading: false,
        error: true,
        submitted: false,
        errorMessage: action.errorMessage,
      });
    default:
      return state;
  }
};

export default submitDAFReducer;
